export default "__VITE_PUBLIC_ASSET__778aca67__"